import { render } from "./ConfirmationBanner.vue?vue&type=template&id=13219eb0&scoped=true"
import script from "./ConfirmationBanner.vue?vue&type=script&lang=js"
export * from "./ConfirmationBanner.vue?vue&type=script&lang=js"

import "./ConfirmationBanner.vue?vue&type=style&index=0&id=13219eb0&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4107429167/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13219eb0"]])

export default __exports__